<div class="offer-banner bg-secondary" *ngIf="currentCompany$ | async as currentCompany">
  <div class="company-image bg-white rounded overflow-hidden d-flex justify-content-center align-items-center">
    <img src="{{ currentCompany.ImageUrl | contentImage: '6' }}" alt="{{ currentCompany.ImageUrl }}" />
  </div>
  <div class="offer-banner-text">
    <h1 class="text-white">{{ currentCompany.DisplayName }}</h1>
    <a class="text-white" href="{{ currentCompany.WebsiteUrl }}" target="_blank">Visit Website</a>
  </div>
</div>

<div class="container offers" *ngIf="currentOffer$ | async as currentOffer">
  <!--Main Offer-->
  <h5 class="text-start text-capitalize fw-bold mb-3 mt-4">Offer</h5>
  <fgb-offers-details [offer]="currentOffer"></fgb-offers-details>
  <!--Other Offers-->
  <div class="row" *ngIf="relatedOffers$ | async as relatedOffers; else noRelatedOffers">
    <div class="col-12">
      <ng-container *ngIf="!!relatedOffers.length; else noRelatedOffers">
        <h5 class="mt-5 text-capitalize mb-3">Other Offers</h5>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let offer of relatedOffers">
            <ng-template carouselSlide [width]="301">
              <fgb-offers-list-item (navigateToOffer)="loadNewOffer($event)" [offer]="offer"></fgb-offers-list-item>
            </ng-template>
          </ng-container>
          <ng-template #noRelatedOffers> No Related Offers </ng-template>
        </owl-carousel-o>
      </ng-container>
    </div>
  </div>
  <!--Offers you may also like-->
  <div class="row" *ngIf="otherOffers$ | async as otherOffers; else noOtherOffers">
    <div class="col-12">
      <ng-container *ngIf="!!otherOffers.length; else noOtherOffers">
        <h5 class="mt-5 text-capitalize mb-3">Similar Offers You May Also Like</h5>
        <owl-carousel-o [options]="customOptions">
          <ng-container *ngFor="let offer of otherOffers">
            <ng-template carouselSlide [width]="301">
              <fgb-offers-list-item (navigateToOffer)="loadNewOffer($event)" [offer]="offer"></fgb-offers-list-item>
            </ng-template>
          </ng-container>
          <ng-template #noOtherOffers> No Other Offers </ng-template>
        </owl-carousel-o>
      </ng-container>
    </div>
  </div>
  <!--Back Button-->
  <div class="d-block">
    <a [routerLink]="[backButtonLink]" class="btn mt-3 d-flex align-items-center h-100 fw-bold">
      <span class="pe-2 icon-arrow-1-left text-primary fw-bold"></span>
      <span class="fw-bold text-primary font-size-14">Back to Offers</span>
    </a>
  </div>
</div>
